import { Box, Container, Typography, Paper, Button } from '@mui/material';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '../config/constants';
import { SEO } from '../components/SEO';

export const PrivacyPolicy = () => {
  const { t } = useTranslation('privacy');
  
  return (
    <>
      <SEO 
        title={t('title')}
        description={t('seoDescription')}
        keywords={t('seoKeywords')}
      />
      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          py: 8,
        }}
      >
        <Container maxWidth="md">
          <Paper elevation={3} sx={{ p: 4 }}>
            <Typography variant="h3" component="h1" gutterBottom fontWeight="bold">
              {t('title')}
            </Typography>
            <Typography variant="body2" color="text.secondary" gutterBottom mb={4}>
              {t('lastUpdated')}
            </Typography>

            <Typography variant="h5" gutterBottom mt={4}>
              {t('sections.introduction.title')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('sections.introduction.content')}
            </Typography>

            <Typography variant="h5" gutterBottom mt={4}>
              {t('sections.dataCollection.title')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('sections.dataCollection.content')}
            </Typography>

            <Typography variant="h5" gutterBottom mt={4}>
              {t('sections.dataUse.title')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('sections.dataUse.content')}
            </Typography>

            <Typography variant="h5" gutterBottom mt={4}>
              {t('sections.dataSecurity.title')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('sections.dataSecurity.content')}
            </Typography>

            <Typography variant="h5" gutterBottom mt={4}>
              {t('sections.userRights.title')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('sections.userRights.content')}
            </Typography>

            <Typography variant="h5" gutterBottom mt={4}>
              {t('sections.contact.title')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('sections.contact.content')}
            </Typography>

            <Typography variant="body1" paragraph mt={4}>
              {t('contactInfo')}{' '}
              <Typography
                component="a"
                href={`mailto:${t('contactEmail')}`}
                sx={{
                  color: 'primary.main',
                  fontWeight: 'bold',
                  textDecoration: 'underline',
                }}
              >
                {t('contactEmail')}
              </Typography>
            </Typography>

            <Box textAlign="center" mt={6}>
              <Button
                component={Link}
                to={ROUTES.HOME}
                variant="contained"
                size="large"
                sx={{ px: 4 }}
              >
                {t('backToHome')}
              </Button>
            </Box>
          </Paper>
        </Container>
      </Box>
    </>
  );
};
